/**
 * Report Service - With S3 storage and export logs
 */

import { callAPI } from '../../network/networkConnection';

const BASE_URL = process.env.REACT_APP_APIUrl + 'admin/reports';

export const ReportService = {
  getStats: () => callAPI(`${BASE_URL}/stats`, 'GET', { 'Content-Type': 'application/json' }, null),

  getFilterOptions: () => callAPI(`${BASE_URL}/filter-options`, 'GET', { 'Content-Type': 'application/json' }, null),

  getExportCount: (type, filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') params.append(key, value);
    });
    const queryString = params.toString() ? `?${params.toString()}` : '';
    return callAPI(`${BASE_URL}/count/${type}${queryString}`, 'GET', { 'Content-Type': 'application/json' }, null);
  },

  startExport: (reportType, filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') params.append(key, value);
    });
    const queryString = params.toString() ? `?${params.toString()}` : '';
    return callAPI(`${BASE_URL}/export/${reportType}${queryString}`, 'POST', { 'Content-Type': 'application/json' }, null);
  },

  getExportStatus: (exportId) => callAPI(`${BASE_URL}/export/${exportId}/status`, 'GET', { 'Content-Type': 'application/json' }, null),

  getDownloadUrl: (exportId) => callAPI(`${BASE_URL}/export/${exportId}/download`, 'GET', { 'Content-Type': 'application/json' }, null),

  getExportLogs: (page = 1, limit = 20, filters = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (filters.reportType) params.append('reportType', filters.reportType);
    if (filters.status) params.append('status', filters.status);
    return callAPI(`${BASE_URL}/logs?${params.toString()}`, 'GET', { 'Content-Type': 'application/json' }, null);
  },

  deleteExport: (exportId) => callAPI(`${BASE_URL}/export/${exportId}`, 'DELETE', { 'Content-Type': 'application/json' }, null),

  cleanupOldExports: () => callAPI(`${BASE_URL}/cleanup`, 'POST', { 'Content-Type': 'application/json' }, null),
};

export default ReportService;
